import React from 'react';

import { CircleBadgeColor } from './types';
import './styles.css';
import type { Icon as BootstrapIcon } from 'react-bootstrap-icons';

interface CircleBadgeProps {
  outerCircleColor?: CircleBadgeColor;
  color?: CircleBadgeColor;
  size?: number;
  child: BootstrapIcon | string | React.ReactNode;
  onClick?: () => void;
  className?: string;
  dataTip?: boolean;
  dataFor?: string;
}

const CircleBadge = ({
  size = 26,
  child,
  onClick,
  className = '',
  outerCircleColor,
  color = CircleBadgeColor.GREEN,
  dataTip,
  dataFor,
}: CircleBadgeProps) => {
  const outerCircleSize = size;
  const innerCircleSize = size * 0.8;
  const childCircleSize = size * 0.6;
  const Child = React.useMemo(() => {
    if (typeof child === 'string') {
      return child as string;
    }
    return child as BootstrapIcon;
  }, [child]);

  const outerStyle = React.useMemo(
    () => ({
      width: `${outerCircleSize}px`,
      height: `${outerCircleSize}px`,
      backgroundColor: outerCircleColor || color,
    }),
    [outerCircleSize, outerCircleColor, color],
  );

  const innerStyle = React.useMemo(
    () => ({
      width: `${innerCircleSize}px`,
      height: `${innerCircleSize}px`,
      borderRadius: '50%',
      backgroundColor: '#fff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }),
    [innerCircleSize],
  );

  const childStyle = React.useMemo(
    () => ({
      width: `${childCircleSize}px`,
      height: `${childCircleSize}px`,
      borderRadius: '50%',
      backgroundColor: color,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '9px',
      color: '#fff',
      fontFamily: 'Open Sans',
      fontWeight: '700',
      padding: '1px',
    }),
    [childCircleSize, color],
  );

  const onClickHandler = React.useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
    if (onClick) {
      onClick();
    }
  }, []);
  return (
    <button
      onClick={onClickHandler}
      className={`circle-badge-container ${className}`}
      style={outerStyle}
      data-tip={dataTip}
      data-for={dataFor}
    >
      <div style={innerStyle}>
        <div style={childStyle}>
          {typeof Child === 'string' ? (
            <span>{Child}</span>
          ) : (
            <Child size={11} color="white" />
          )}
        </div>
      </div>
    </button>
  );
};

export default CircleBadge;
